import { TopicState } from 'mk2/apps/forum/containers/Topic/Topic.reducers';
import { initialState as initialInfiniteListState, State as InfiniteListState } from 'mk2/reducers/infiniteList';

export const TOPIC_MENU_MORE = 'topic-more';

export const initialPostsState: InfiniteListState = initialInfiniteListState;

export const initialTopicState: TopicState = {
    posts: {},
    errorMessage: null,
    isSubscribed: false,
    newContributors: 0,
    campaign: null,
    counselling: null,
    counsellingPostsCount: null,
    subscribers: 0,
};
